import { useApiSubmit } from '@hooks/use-api-submit';
import type { IApiSubmitResultBase } from '@/types/api';

const LOGIN_AS_ENDPOINT = '/api/register/login-as';

export const useLoginAs = (token: string) => {
    const { submit, isSubmitting, submitError } = useApiSubmit<void, unknown, IApiSubmitResultBase>(
        LOGIN_AS_ENDPOINT,
        () => ({ token }),
        () => ({}),
        'This login link is invalid or has expired.',
    );

    return { redeem: submit, isRedeeming: isSubmitting, error: submitError };
};
